import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const MessageList = ({ messages, isThinking }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isThinking]);

  if (messages.length === 0 && !isThinking) {
    return (
      <div className="message-list empty">
        <div className="empty-state">
          <p>Start the conversation by typing a message below.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="message-list">
      {messages.map((message, index) => (
        <div
          key={message.id || index}
          className={`message ${message.role === 'user' ? 'user-message' : 'ai-message'}`}
        >
          <div className="message-content">
            {message.content}
          </div>
        </div>
      ))}
      {isThinking && (
        <div className="message ai-message thinking-message">
          <div className="message-content">
            <div className="thinking-dots">
              <div className="thinking-dot" />
              <div className="thinking-dot" />
              <div className="thinking-dot" />
            </div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

MessageList.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      sender: PropTypes.string,
      timestamp: PropTypes.string
    })
  ).isRequired,
  isThinking: PropTypes.bool
};

MessageList.defaultProps = {
  isThinking: false
};

export default MessageList;